<template>
  <div
    class="flex h-full flex-col items-center justify-center gap-legacy-s rounded-md bg-green-5 p-legacy-m pb-legacy-l text-center"
  >
    <UIcon
      name="fa7-solid:info-circle"
      size="2em"
      class="text-green-pop"
    />
    <p class="text-sm text-green-50">
      Dette produktet kan ikke bestilles av privatpersoner (med Vipps).
      <LoginLink class="underline" provider="feide">
        Logg inn som bedrift (med Feide)
      </LoginLink> for å bestille.
    </p>
  </div>
</template>
